var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.386,
    height: 16.95,
    viewBox: "0 0 22.386 16.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-278.172 -262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,15l4.153,4.153L18.805,15",
    transform: "translate(274.679 253.814)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.001 263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.45,22.5v3.322a1.661,1.661,0,0,1-1.661,1.661H6.161A1.661,1.661,0,0,1,4.5,25.822V22.5",
    transform: "translate(-1.644 -12.533)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14.467V4.5",
    transform: "translate(-7.669 -4.5)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0S1.377,2.519,3.405.652",
    transform: "matrix(-0.839, -0.545, 0.545, -0.839, 2.856, 10.244)",
    fill: "none",
    stroke: "#2cccd3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.284S1.412-1.128,3.493.66",
    transform: "matrix(0.839, -0.545, 0.545, 0.839, 17.106, 9.167)",
    fill: "none",
    stroke: "#2cccd3",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoIcon);
export default __webpack_public_path__ + "static/media/cargo-icon.f189860a.svg";
export { ForwardRef as ReactComponent };